import { PUZZLE_LENGTH } from '@wt/app/game/_components/PuzzleLoader';
import { nullFunc } from '@wt/utilities/nullFunction';

export interface GameRound {
  image: File | string | null;
  location: mapkit.Coordinate | null;
  year: string;
  description: string;
  valid: boolean; // is all round data valid
  isOpen: boolean; // is round form opened or collapsed
  loadingMetadata: boolean; // is round image metadata being extracted
  photographer?: string;
}

export const initialNewGameRound: GameRound = {
  image: null,
  location: null,
  year: '',
  description: '',
  valid: false,
  isOpen: false,
  loadingMetadata: false,
  photographer: undefined,
};

// used when editing
// so we can see if any fields have been changed
export interface GameToEdit {
  slug: string;
  name: string;
  publicGame: boolean;
  rounds: GameRound[];
}
export interface GameFormContextType {
  name: string;
  setName: (e: string) => void;
  publicGame: boolean;
  setPublicGame: (e: boolean) => void;
  acceptedCopyright: boolean;
  setAcceptedCopyright: (e: boolean) => void;
  acceptedCommunityGuidelines: boolean;
  setAcceptedCommunityGuidelines: (e: boolean) => void;
  rounds: GameRound[];
  setRounds: (r: GameRound[]) => void;
  setRoundData: (r: Partial<GameRound>, i: number) => void;
  loading: boolean;
  formDataValid: boolean;
  imagesUploaded: number;
  saveGame: () => void;
  isEdit: boolean;
  setGameToEdit: (e: GameToEdit) => void;
  hasChanges: boolean;
  showConfirmationModal: boolean;
  setShowConfirmationModal: (e: boolean) => void;
  hasDraft: boolean;
  deleteDraft: () => void;
  deleteGame: () => void;
  deleting: boolean;
  showGuidelinesModal: boolean;
  setShowGuidelinesModal: (e: boolean) => void;
  closeGuidelinesModal: () => void;
  firstTimeViewingGuidelinesModal: boolean;
}

export const initialGameFormContextValue: GameFormContextType = {
  name: '',
  setName: nullFunc,
  publicGame: true,
  setPublicGame: nullFunc,
  acceptedCopyright: false,
  setAcceptedCopyright: nullFunc,
  acceptedCommunityGuidelines: false,
  setAcceptedCommunityGuidelines: nullFunc,
  rounds: Array.from({ length: PUZZLE_LENGTH }, () => initialNewGameRound),
  setRounds: nullFunc,
  setRoundData: nullFunc,
  loading: false,
  formDataValid: false,
  imagesUploaded: 0,
  saveGame: nullFunc,
  isEdit: false,
  setGameToEdit: nullFunc,
  hasChanges: false,
  showConfirmationModal: false,
  setShowConfirmationModal: nullFunc,
  hasDraft: false,
  deleteDraft: nullFunc,
  deleteGame: nullFunc,
  deleting: false,
  showGuidelinesModal: false,
  setShowGuidelinesModal: nullFunc,
  closeGuidelinesModal: nullFunc,
  firstTimeViewingGuidelinesModal: false,
};
